<template>
    <div>
        <span v-if="response === null">
            <span v-if="fancySpinner">
                <LoadingSpinner :small-spinner="true"/>
            </span>
            <span v-else>
                <i class="fas fa-spinner fa-spin"></i>
            </span>
        </span>
        <span v-else>
            <div class="is-light is-rounded">
                <span><p >{{ response.length }}</p></span>
            </div>
        </span>
    </div>
</template>

<script>
import LoadingSpinner from '@/widgets/LoadingSpinner.vue'
import { getDetections } from '@/js/apis.js'
export default {
    name: 'DetectionsSpinner',
    components: {LoadingSpinner},
    props: {
        soundFileKey: {type: String},
        requestingUser: {type: String, default: ""},
        fancySpinner: {type: Boolean, default: false},
    },
    emits: ['responseReceived'],
    data(){return {response: null,}},
    async mounted(){
        this.response = await getDetections(this.requestingUser, this.soundFileKey)
        this.$emit('responseReceived', this.response)
    },
}
</script>

